module.exports = function() {
  return new Worker(__webpack_public_path__ + "6321bdc0c7a617ef0434.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/components/aviasim/engine/babel.worker.js
// module id = 314
// module chunks = 3